import { Transerializable } from '@eventops/athlinks-get-or'
import {  } from '../common/calendarTime'
import {
  CalendarTime,
  EventStatus,
  ICalendarTime,
  IntervalType
} from '..'

export interface IDivisionMetadata {
  id: number,
  name: string
}

export interface IIntervalMetadata {
  distance: number,
  displayOrder: number,
  id: number,
  name: string,
  isFull: boolean,
  intervalType: IntervalType
}

export interface IntervalDivisionMetadata {
  divisions: IDivisionMetadata[],
  intervals: IIntervalMetadata[],
}

export interface IEventCourseMetadata {
  courseId: number,
  eventCourseId: number,
  eventCourseName: string,
  metadata: IntervalDivisionMetadata,
  raceType: string,
  distance: number,
  eventCourseStartDateTime: ICalendarTime,
  preferedDistanceUnit: string,
  isVirtual: boolean,
  minAllowedTicks: number,
  maxAllowedTicks: number,
  eventCourseEndDateTime: ICalendarTime
}

export interface IEventMetadata {
  eventId: number,
  eventCourseMetadata: IEventCourseMetadata[],
  eventName: string,
  eventStartDateTime: ICalendarTime,
  eventEndDateTime: ICalendarTime,
  eventStatus: EventStatus
}

export class MetadataImpl extends Transerializable implements IEventMetadata {
  public eventId: number = 0
  public eventName: string = ''
  public eventStatus: EventStatus = EventStatus.NotSet
  public eventCourseMetadata: IEventCourseMetadata[] = []
  public eventStartDateTime = new CalendarTime()
  public eventEndDateTime = new CalendarTime()
  public eventEpochEndTime = new CalendarTime()
  public courseDistance = 0
}
